/**
 * errors.ts — Helper local Zod → AppError pour le module kot-print-jobs.
 *
 * Calqué sur src/api/draft-orders/errors.ts.
 * Invariant 4.A.15 : aucun PII loggé.
 */

import type { z } from 'zod';
import { validationError } from '@/api/errors';
import type { AppError } from '@/api/errors';

/**
 * Convertit la première issue d'une ZodError en AppError de type validation.
 * @param error    ZodError retourné par safeParse.
 * @param fallback Message par défaut si issues est vide.
 */
export function firstZodIssueToValidationError(error: z.ZodError, fallback: string): AppError {
  const issue = error.issues[0];
  return validationError(issue?.path.join('.') ?? 'unknown', issue?.message ?? fallback);
}
